import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { ApiService } from '../../service/api_service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, FormGroup } from '@angular/forms';
import * as $ from 'jquery';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs'; 

@Component({
    selector: 'app-expensemaster',
    template: require('./expensemaster.component.html'),
    styles: [require('./expensemaster.component.css')],
})
export class ExpenseMasterComponent implements OnInit {

    @ViewChild('content') content;
    expDetails: any = [];
    closeResult: any = '';
    busy: Subscription;
    viewModal: boolean = false;
    editModal: boolean = false;
    addModal: boolean = false;

    expenseForm = new FormGroup({
        empName: new FormControl(''),
        validFrom: new FormControl(''),
        daLocal: new FormControl(''),
        daLocalPlus: new FormControl(''),
        daEx: new FormControl(''),
        daOs: new FormControl(''),
        target: new FormControl(''),
        fareRate1: new FormControl(''),
        uptoKm1: new FormControl(''),
        fareRate2: new FormControl(''),
        uptoKm2: new FormControl('')
    })
    private rowHeight;
    private columnDefs;
    api: any;
    columnApi: any;
    defaultColDefine;
    private gridColumnApi;
    empCode: any;
    empId: any;
    token:any;

    static parameters = [ApiService, NgbModal, ToastrService]
    currentDate: string;
    currentMonth: string;
    constructor(
        private apiService: ApiService,
        private modalService: NgbModal,
        private toastr: ToastrService

    ) {

        var self = this;

        var date = new Date();
        this.currentDate = date.getFullYear() + '-' + (date.getMonth() + 1).toString().padStart(2, "0");
        this.currentMonth = this.currentDate;

        this.columnDefs = [
            // { headerName: 'S.No.', valueGetter: "node.rowIndex + 1", width: 80 },
            { headerName: 'Employee', field: "EmployeeName", suppressFilter: true, pinned: 'left' },
            { headerName: 'Designation', field: "Designation" },
            { headerName: 'Valid From', field: "ValidFrom" },
            { headerName: 'DA Local', field: "DaLocal" },
            { headerName: 'DA Local +', field: "DaLocalPlus" },
            { headerName: 'DA EX', field: "DaEx" },
            { headerName: 'DA OS', field: "DaOs" },
            { headerName: 'Target', field: "Target" },
            { headerName: 'Fare Rate 1', field: "FareRate1" },
            { headerName: 'Upto KM', field: "KM1" },
            { headerName: 'Fare Rate 2', field: "FareRate2" },
            { headerName: 'Upto KM', field: "KM2" },
            {
                headerName: 'Action', field: "Action", width: 150, pinned: 'right', cellRenderer: function (params) {
                    var eDiv = document.createElement('div');
                    var Div = `
                    <div class="grid_actions"><span class="viewBtn grid_actions_item" data-target="#addEmployeeDAMaster" data-toggle="modal"><i class="icon-view"></i></span>`;
                    if(params.data.EmployeeId){
                        Div = Div + `<span class="editBtn grid_actions_item" data-target="#addEmployeeDAMaster" data-toggle="modal"><i class="icon-edit"></i></span>`;
                    } else {
                        Div = Div + `<span class="editBtn grid_actions_item" data-target="#addEmployeeDAMaster" data-toggle="modal"><i class="icon-add"></i></span>`;
                    }
                    Div = Div + `</div>`;
                    eDiv.innerHTML = Div;
                    var viewButton = eDiv.querySelectorAll('.viewBtn')[0];
                    var editButton = eDiv.querySelectorAll('.editBtn')[0];
                    viewButton.addEventListener('click', function () {
                        self.viewModal = true;
                        self.editModal = false;
                        self.addModal = false;
                        self.formValueSet(params.data);
                        console.log('self.editModal', self.editModal);
                    });

                    editButton.addEventListener('click', function () {
                        self.viewModal = false;
                        self.editModal = false;
                        self.addModal = false;
                        self.empCode = params.data.EmployeeCode;
                        self.empId = params.data.EmployeeId;
                        if (params.data.EmployeeId) {
                            self.editModal = true;
                            self.formValueSet(params.data);
                        } else {
                            self.addModal = true;
                            self.expenseForm.reset();
                            self.expenseForm.controls['validFrom'].setValue(self.currentMonth);
                            self.expenseForm.controls['empName'].setValue(params.data.EmployeeName);
                        }                        
                    });
                    return eDiv;
                }
            }
        ];
        this.rowHeight = 50;
        this.defaultColDefine = { resizable: true };

    }

    ngOnInit() {
        this.token = JSON.parse(sessionStorage.getItem("currentUser"));
        this.getExpDetails();

    }

    formValueSet(data) {
        console.log('this.expenseForm.value.EmployeeName', data.ValidFrom, typeof data.ValidFrom);
        this.expenseForm.controls['empName'].setValue(data.EmployeeName);
        this.expenseForm.controls['validFrom'].setValue(data.ValidFrom);
        this.expenseForm.controls['daLocal'].setValue(data.DaLocal);
        this.expenseForm.controls['daLocalPlus'].setValue(data.DaLocalPlus);
        this.expenseForm.controls['daEx'].setValue(data.DaEx);
        this.expenseForm.controls['daOs'].setValue(data.DaOs);
        this.expenseForm.controls['target'].setValue(data.Target);
        this.expenseForm.controls['fareRate1'].setValue(data.FareRate1);
        this.expenseForm.controls['uptoKm1'].setValue(data.KM1);
        this.expenseForm.controls['fareRate2'].setValue(data.FareRate2);
        this.expenseForm.controls['uptoKm2'].setValue(data.KM2);
    }

    private getAddReason(reason: any) {
        this.addModal = false;
    }

    onGridReady = (params) => {
        this.api = params.api;
        this.gridColumnApi = params.columnApi;
    }

    onBtnExport() {
        this.api.exportDataAsCsv({ fileName: 'ExpenseMaster' });
    }

    onFilterTextBoxChanged() {
        this.api.setQuickFilter(document.querySelector<HTMLInputElement>('#filter-text-box')!.value);
    }

    sizeToFit(skipHeader) {
        var allColumnIds = [];
        this.gridColumnApi.getAllColumns().forEach(function (column) {
            allColumnIds.push(column.colId);
        });
        this.gridColumnApi.autoSizeColumns(allColumnIds, skipHeader);
    }

    oncellclicked(event) {
        console.log('on cell clicked', event);
    }

    getExpDetails() {
        var data = {
            Id: this.token.id
        };
      this.busy  = this.apiService.getExpenseMaster(data).subscribe((res: any) => {
            this.expDetails = res.data;
            console.log('expDetails', this.expDetails);
            
        })
    }

    saveExpense() {
        let data: any = this.expenseForm.value;
        data.empCode = this.empCode;
        data.empId = this.empId;
        console.log('data', data);
       this.busy = this.apiService.saveExpense(data).subscribe((res: any) => {
            console.log('response', res);
            this.expenseForm.reset();
            this.toastr.success('Expense saved successfully.');
            this.getExpDetails();
        })

    }

    updateExpense() {
        let data: any = this.expenseForm.value;
        data.empCode = this.empCode;
        data.empId = this.empId;
        console.log('update expense', data);
        this.busy = this.apiService.updateExpense(data).subscribe((res: any) => {
            console.log('response', res);
            this.expenseForm.reset();
            this.toastr.success('Expense updated successfully.');
            this.getExpDetails();
        })
    }
}
